import React from "react";

function DescriptionAboutProductForm() {
  return (
    <div className="p-5 border-2 border-gray-300 rounded-xl my-5">
      <p className="font-semibold text-gray-600 text-xl underline">
        Descriptions About Products
      </p>

      {/* Product Description */}
      <div className="w-full px-10 mt-4">
        <label className="block font-medium text-gray-700 mb-2" htmlFor="productDescription">
          Product Description<span className="text-red-500">*</span>
        </label>
        <textarea
          id="productDescription"
          className="w-full border border-gray-300 rounded p-2 outline-none focus:border-blue-500 h-48"
          placeholder="Write Description About Product"
        ></textarea>
      </div>

      {/* Product Variants */}
      <div className="w-full px-10 mt-4">
        <label className="block font-medium text-gray-700 mb-2 outline-none focus:border-blue-500" htmlFor="productVariants">
          Product Varients<span className="text-red-500">*</span>
        </label>
        <textarea
          id="productVariants"
          className="w-full border border-gray-300 rounded p-2 outline-none focus:border-blue-500 h-48"
          placeholder="Write Description About Product Varients"
        ></textarea>
      </div>

      {/* Product Certifications */}
      <div className="w-full px-10 mt-4">
        <label className="block font-medium text-gray-700 mb-2 outline-none focus:border-blue-500" htmlFor="productCertifications">
          Product Certifications<span className="text-red-500">*</span>
        </label>
         <textarea
          id="productCertifications"
          className="w-full border border-gray-300 rounded p-2 outline-none focus:border-blue-500 h-48"
          placeholder="Enter Tags About Product Certification, use ( , ) for multiple"
        ></textarea>
      </div>
    </div>
  );
}

export default DescriptionAboutProductForm;
